import { cn } from '@/utils/tailwind';

import { CELL_PADDING } from '../../DatasetSessionCompare.utils';
import { isInPlayground } from '../../utils/isInPlayground';

export const SingleExperimentCell = ({
  columnIndex,
  columnWidthStorage,
  isTruncated,
  children,
  minColumnWidth,
  className,
}: {
  columnIndex: number;
  columnWidthStorage: number[];
  isTruncated: boolean;
  children: React.ReactNode;
  minColumnWidth: number;
  className?: string;
}) => {
  const inPlayground = isInPlayground();
  return (
    <td
      className={cn(
        'group h-full overflow-hidden border-b border-r border-secondary',
        isTruncated ? '' : 'align-top',
        className
      )}
      style={{
        ...CELL_PADDING(inPlayground ? 'lg' : 'sm'),
        width: columnWidthStorage[columnIndex] ?? minColumnWidth,
        maxWidth: columnWidthStorage[columnIndex] ?? minColumnWidth,
        minWidth: columnWidthStorage[columnIndex] ?? minColumnWidth,
      }}
      data-column={columnIndex}
    >
      {children}
    </td>
  );
};
